const VK_PIXEL_ID = process.env.REACT_APP_VK_PIXEL_ID || '3782588';
const VK_PIXEL_SCRIPT_ID = 'speeddate-vk-pixel-script';
const VK_GOAL_DEDUP_KEY_PREFIX = 'speeddate_vk_goal_sent';
const VK_PIXEL_STATE_KEY = '__speedDateVkPixelState';
const inMemoryDedupeKeys = new Set();

const canUseBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const getPixelId = () => {
  const pixelId = Number(VK_PIXEL_ID);
  return Number.isFinite(pixelId) && pixelId > 0 ? pixelId : null;
};

const getPixelState = () => {
  window[VK_PIXEL_STATE_KEY] = window[VK_PIXEL_STATE_KEY] || {
    initializedPixelIds: {},
  };

  return window[VK_PIXEL_STATE_KEY];
};

const normalizeDedupeId = (value) => {
  if (value == null) {
    return '';
  }

  return String(value).trim().replace(/[^a-zA-Z0-9:._-]/g, '').slice(0, 128);
};

const hasDedupeKey = (key) => {
  if (inMemoryDedupeKeys.has(key)) {
    return true;
  }

  try {
    return Boolean(window.localStorage?.getItem(key));
  } catch (error) {
    console.warn('VK Pixel dedupe read skipped:', error);
    return false;
  }
};

const setDedupeKey = (key) => {
  inMemoryDedupeKeys.add(key);

  try {
    window.localStorage?.setItem(key, new Date().toISOString());
  } catch (error) {
    console.warn('VK Pixel dedupe write skipped:', error);
  }
};

export const initVkPixel = () => {
  if (!canUseBrowser()) {
    return false;
  }

  const pixelId = getPixelId();
  if (!pixelId) {
    return false;
  }

  window._tmr = window._tmr || [];
  const state = getPixelState();

  if (!state.initializedPixelIds[pixelId]) {
    window._tmr.push({ id: pixelId, type: 'pageView', start: new Date().getTime() });
    state.initializedPixelIds[pixelId] = true;
  }

  if (!document.getElementById(VK_PIXEL_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = VK_PIXEL_SCRIPT_ID;
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://top-fwz1.mail.ru/js/code.js';
    script.dataset.pixelId = String(pixelId);
    document.head.appendChild(script);
  }

  return true;
};

export const reachVkGoal = (goalName, params = {}) => {
  const pixelId = getPixelId();
  if (!pixelId || !initVkPixel()) {
    return false;
  }

  window._tmr.push({
    type: 'reachGoal',
    id: pixelId,
    goal: goalName,
    params,
  });

  return true;
};

export const reachVkGoalOnce = (goalName, dedupeId, params = {}) => {
  if (!canUseBrowser()) {
    return false;
  }

  const normalizedDedupeId = normalizeDedupeId(dedupeId);
  if (!normalizedDedupeId) {
    return reachVkGoal(goalName, params);
  }

  const dedupeKey = `${VK_GOAL_DEDUP_KEY_PREFIX}:${goalName}:${normalizedDedupeId}`;
  if (hasDedupeKey(dedupeKey)) {
    return false;
  }

  const sent = reachVkGoal(goalName, params);
  if (sent) {
    setDedupeKey(dedupeKey);
  }

  return sent;
};

export const trackVkRegistrationStart = (attemptId) =>
  reachVkGoalOnce('registration_start', attemptId);

export const trackVkRegistrationFormSubmitted = (attemptId) =>
  reachVkGoalOnce('registration_form_submitted', attemptId);

export const trackVkRegistrationConfirmed = (registrationConversionId) =>
  reachVkGoalOnce('registration_confirmed', registrationConversionId, {
    conversion_id: normalizeDedupeId(registrationConversionId),
  });
